import { isOrbitHistoryTurn, useOrbitSessionLookup, useOrbitSessionRecord } from 'api/orbit';

import { useOrbitContext } from './OrbitContext';
import { groupTurnsBySession, openChatTitle } from './groupTurnsBySession';
import { OrbitSession } from './types';

export interface IOrbitOpenChat {
  sessionId: string | null;
  /** The server's row for the chat; undefined until a list, a lookup or a PATCH has returned it. */
  record: OrbitSession | undefined;
  /** The server's title, else the first question cut to 60 characters; undefined with neither. */
  title: string | undefined;
}

/**
 * The chat open in the provider, as the header and the panel's name bar show it. A listable chat
 * no mounted list holds is looked up by its own question.
 */
const useOrbitOpenChat = (): IOrbitOpenChat => {
  const { sessionId, turns } = useOrbitContext();
  const record = useOrbitSessionRecord(sessionId);
  const listable = turns.some(isOrbitHistoryTurn);

  useOrbitSessionLookup(
    record === undefined && sessionId !== null && listable
      ? groupTurnsBySession(turns)[0]?.firstQuestion ?? null
      : null
  );

  return { sessionId, record, title: record?.title ?? openChatTitle(turns) };
};

export default useOrbitOpenChat;
